import { render, staticRenderFns } from "./aceite.vue?vue&type=template&id=f581d2b4&scoped=true&"
import script from "./aceite.vue?vue&type=script&lang=js&"
export * from "./aceite.vue?vue&type=script&lang=js&"
import style0 from "./aceite.vue?vue&type=style&index=0&id=f581d2b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f581d2b4",
  null
  
)

export default component.exports